/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Owned_TagInputs */

const en_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlocked`)
};

const ar_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم فتحه`)
};

const de_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freigeschaltet`)
};

const es_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueado`)
};

const fr_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloqué`)
};

const it_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sbloccato`)
};

const ja_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アンロック済み`)
};

const ko_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠금 해제됨`)
};

const pt_br_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueado`)
};

const ru_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокировано`)
};

const th_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกแล้ว`)
};

const tr_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilidi açıldı`)
};

const zh_cn_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已解锁`)
};

const zh_tw_owned_tag = /** @type {(inputs: Owned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已解鎖`)
};

/**
* | output |
* | --- |
* | "Unlocked" |
*
* @param {Owned_TagInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const owned_tag = /** @type {((inputs?: Owned_TagInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Owned_TagInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_owned_tag(inputs)
	if (locale === "ar") return ar_owned_tag(inputs)
	if (locale === "de") return de_owned_tag(inputs)
	if (locale === "es") return es_owned_tag(inputs)
	if (locale === "fr") return fr_owned_tag(inputs)
	if (locale === "it") return it_owned_tag(inputs)
	if (locale === "ja") return ja_owned_tag(inputs)
	if (locale === "ko") return ko_owned_tag(inputs)
	if (locale === "pt_br") return pt_br_owned_tag(inputs)
	if (locale === "ru") return ru_owned_tag(inputs)
	if (locale === "th") return th_owned_tag(inputs)
	if (locale === "tr") return tr_owned_tag(inputs)
	if (locale === "zh_cn") return zh_cn_owned_tag(inputs)
	return zh_tw_owned_tag(inputs)
});